module.exports = __webpack_public_path__ + "static/media/Avatar.f01bd276.png";